
// You can write more code here

/* START OF COMPILED CODE */

import DecorationImage from "../DecorationImage";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class DecorationHelpSwitch extends DecorationImage {

  constructor(scene: Phaser.Scene, x?: number, y?: number, texture?: string, frame?: number | string) {
    super(scene, x ?? 68.5, y ?? 72.5, texture || 'game-all', frame ?? "help-switch.png");

    /* START-USER-CTR-CODE */
    this.scene.time.delayedCall(500, () => {
      this.awake();
    });
    /* END-USER-CTR-CODE */
  }

  public AnimateTime: number = 0;

  /* START-USER-CODE */

  private startScale:number = 1;

  protected awake(){
    this.startScale = this.scale;
    this.scene.time.delayedCall(this.AnimateTime, () => {
      this.animateButton();
    });
  }

  private animateButton(){
    if(this.scene){
      if (!this.scene.sys.game.device.os.desktop) {
        this.scene.add.tween({
          targets: this,
          scale:0.7* this.startScale,
          duration: 200,
          ease: Phaser.Math.Easing.Cubic.In,
          delay: 0
        });
        this.scene.add.tween({
          targets: this,
          scale: this.startScale,
          duration: 200,
          ease: Phaser.Math.Easing.Cubic.Out,
          delay: 210
        });
      }
    }
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
